module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-content r-center"
  }, [_c('div', {
    staticClass: "clearfix m-t-30"
  }, [_c('div', {
    staticClass: "f-1"
  }, [_vm._v(_vm._s(_vm.postDetail.title))]), _vm._v(" "), _c('div', {
    staticClass: "f-2 m-t-20"
  }, [_vm._v("时间：" + _vm._s(_vm.postDetail.createTime.substring(0, 10)) + "\n       编辑：" + _vm._s(_vm.postDetail.editor))]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('span', {
    staticClass: "rectangle-theme f-3"
  }, [_vm._v(_vm._s(_vm.postDetail.themeTitle))])])]), _vm._v(" "), _c('div', [(_vm.postDetail.type === 1) ? _c('div', {
    staticClass: "m-b-33"
  }, _vm._l((_vm.postDetail.content), function(pc) {
    return _c('div', [(pc.title != '') ? _c('div', {
      staticClass: "f-1 m-t-35"
    }, [_vm._v(_vm._s(pc.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "r-left content-area f-4 m-t-30"
    }, [_vm._v(_vm._s(pc.text))]), _vm._v(" "), _c('img', {
      staticClass: "img-n-detail-div m-t-20",
      attrs: {
        "src": pc.image
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.postDetail.type === 2) ? _c('div', {
    staticClass: "m-b-33"
  }, _vm._l((_vm.postDetail.content), function(pc) {
    return _c('div', [(pc.title != '') ? _c('div', {
      staticClass: "f-1 m-t-35"
    }, [_vm._v(_vm._s(pc.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "r-left content-area f-4 m-t-30"
    }, [_vm._v(_vm._s(pc.text))]), _vm._v(" "), _c('img', {
      staticClass: "img-n-detail-div m-t-20",
      attrs: {
        "src": pc.image
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.postDetail.type === 3) ? _c('div', {
    staticClass: "m-b-33"
  }) : _vm._e(), _vm._v(" "), (_vm.postDetail.type === 4) ? _c('div', {
    staticClass: "m-b-33"
  }, [_vm._v("\n      " + _vm._s( /** 视频 */ ) + "\n      "), _c('div', {
    staticClass: "r-left content-area f-4 m-t-30"
  }, [_vm._v(_vm._s(_vm.postDetail.content.text))]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('video-player', {
    attrs: {
      "options": _vm.videoOptions
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa167256"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsDetail.vue
// module id = 614
// module chunks = 1